import axios from "axios";

export default {
  getCity(zipCode) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.GEO_SERVICE_PUBLIC_PATH}/region/${zipCode}`
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error.response));
    });
  },
  getProviders(zipCode) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.GEO_SERVICE_PUBLIC_PATH}/region/${zipCode}/energy-providers`
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error.response));
    });
  },
  getRegion(zipCode) {
    let region = null

    if ((zipCode >= 1300 && zipCode <= 1499) || (zipCode >= 4000 && zipCode <= 7999)) {
      region = "BE-WAL";
    } else if (zipCode >= 1000 && zipCode <= 1299) {
      region = "BE-BRU"

    } else {
      region = "BE-VLG";

    }

    return region;
  }
};



// WEBPACK FOOTER //
// ./src/services/geoService.js